/**
 * Date rendering for the Takata grid.
 *
 * Both functions slice the ISO string the API returned instead of going through
 * `Date`, which is what the Razor page's `fmtDateTime`/`fmtDate` did. That is
 * deliberate, not laziness: the values are `timestamptz` read as UTC, the column
 * filters are parsed as UTC server-side, and the header says "CET" because that
 * is the zone the supplier's data is already in. Parsing to a `Date` would shift
 * every value into the viewer's local zone, so a row would stop matching the
 * date range that returned it.
 */

/** `2025-04-17T09:31:04Z` → `2025-04-17 09:31:04`. */
export function formatCallDateTime(value: string | null | undefined): string {
  return value ? String(value).substring(0, 19).replace('T', ' ') : '';
}

/** `2025-04-17T00:00:00` → `2025-04-17`. */
export function formatCallDate(value: string | null | undefined): string {
  return value ? String(value).substring(0, 10) : '';
}

/**
 * How a wave id reads in a selector: `2026_Wave9`, `Wave 202604_01`, `Wave 0 (legacy)`.
 *
 * The word is only added to ids that do not already carry it. Takata now receives
 * `YYYY_WaveNN`, which prefixed read "Wave 2026_Wave9"; the non-Takata campaign
 * still sends bare `YYYYMM_NN` ids, which say nothing on their own and keep it.
 */
export function waveLabel(wave: string): string {
  if (wave === '0') return 'Wave 0 (legacy)';
  return /wave/i.test(wave) ? wave : `Wave ${wave}`;
}

/** `campaignEntryId-uniqueContactId`; empty when the supplier sent neither. */
export function formatUniqueContactId(
  campaignEntryId: number | null | undefined,
  uniqueContactId: string | null | undefined,
): string {
  if (campaignEntryId == null && !uniqueContactId) return '';
  return `${campaignEntryId ?? ''}-${uniqueContactId ?? ''}`;
}
